import { render, staticRenderFns } from "./DocumentationRequirements.vue?vue&type=template&id=72a669f8&scoped=true"
import script from "./DocumentationRequirements.vue?vue&type=script&lang=ts"
export * from "./DocumentationRequirements.vue?vue&type=script&lang=ts"
import style0 from "./DocumentationRequirements.vue?vue&type=style&index=0&id=72a669f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a669f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a669f8')) {
      api.createRecord('72a669f8', component.options)
    } else {
      api.reload('72a669f8', component.options)
    }
    module.hot.accept("./DocumentationRequirements.vue?vue&type=template&id=72a669f8&scoped=true", function () {
      api.rerender('72a669f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyProjects/ClientTabsComponents/Steps/CarePlanSteps/DocumentationRequirements.vue"
export default component.exports